/**
 * Error codes 23000-23999: the externalLinks module (CP-283 Shareable External Links). Each code is
 * sent beside the call site's own `errorMessage`, which stays the text the client shows.
 */
export const externalLinksErrorCodes = {
  /** "Too many requests. Please try again shortly." — a per-IP throttle on a public route. */
  EXTERNAL_LINK_RATE_LIMITED: 23001,
  /** "File not found" — the streaming route (HTTP 404). */
  EXTERNAL_LINK_FILE_NOT_FOUND: 23002,
  /** "This link is no longer valid" */
  EXTERNAL_LINK_INVALID: 23003,
  /** "Model geometry is not available yet" */
  EXTERNAL_LINK_MODEL_GEOMETRY_NOT_READY: 23004,
  /** "Downloads are disabled on this link" — also a Can View link asked for bytes it cannot render. */
  EXTERNAL_LINK_DOWNLOADS_DISABLED: 23005,
  /** "Only a single file can be previewed" — about the SELECTION. */
  EXTERNAL_LINK_SINGLE_FILE_PREVIEW_ONLY: 23006,
  /** "Office preview is not configured" — no Office (Collabora) server in this environment. */
  EXTERNAL_LINK_OFFICE_PREVIEW_NOT_CONFIGURED: 23007,
  /** "Office preview is unavailable" — the server is configured but failed. */
  EXTERNAL_LINK_OFFICE_PREVIEW_UNAVAILABLE: 23008,
  /** "External sharing is turned off for this portal" */
  EXTERNAL_SHARING_DISABLED: 23009,
  /** "The selected item no longer exists" — the item being shared could not be resolved. */
  EXTERNAL_LINK_ITEM_NOT_FOUND: 23010,
  /** "You need full access on this item to create a shared link" */
  EXTERNAL_LINK_CREATE_REQUIRES_FULL_ACCESS: 23011,
  /** "The selected link no longer exists" */
  EXTERNAL_LINK_NOT_FOUND: 23012,
  /** "You need full access on this item to edit its shared links" */
  EXTERNAL_LINK_EDIT_REQUIRES_FULL_ACCESS: 23013,
  /** "A portal admin has disabled this link. Ask an admin to re-enable it first." */
  EXTERNAL_LINK_DISABLED_BY_ADMIN: 23014,
  /** "The shared item no longer exists" — the already-shared path, distinct from 23010. */
  EXTERNAL_LINK_SHARED_ITEM_NOT_FOUND: 23015,
  /** "You do not have access to this item" */
  EXTERNAL_LINK_ITEM_NO_ACCESS: 23016,
  /** "Only portal admins can view the external links register" */
  EXTERNAL_LINKS_REGISTER_ADMIN_ONLY: 23017,
  /** "Only portal admins can disable external links" */
  EXTERNAL_LINKS_DISABLE_ADMIN_ONLY: 23018,
  /** "This file type has no converted preview" — about the FILE TYPE, distinct from 23006. */
  EXTERNAL_LINK_NO_CONVERTED_PREVIEW: 23019,
  /** "A link with this name already exists on this item" — checked only after the access gate. */
  EXTERNAL_LINK_DUPLICATE_NAME: 23020,
  /** "You need full access on this item to revoke its shared links" */
  EXTERNAL_LINK_REVOKE_REQUIRES_FULL_ACCESS: 23021,
  /** "You need full access on this item to enable its shared links" */
  EXTERNAL_LINK_ENABLE_REQUIRES_FULL_ACCESS: 23022,
  /** "The expiry date must be in the future" */
  EXTERNAL_LINK_EXPIRY_MUST_BE_FUTURE: 23023,
  /**
   * "This link is password protected. Please unlock it to continue." — a recipient's share session
   * expired mid-view on a password-protected link. The link is still good, it just needs unlocking
   * again, which is what separates it from EXTERNAL_LINK_INVALID (23003).
   */
  EXTERNAL_LINK_UNLOCK_REQUIRED: 23024,
};
